
import { useState, useEffect } from 'react';

const DEBOUNCE_MS = 300;

function useDebounce<T>(value: T, delay: number = DEBOUNCE_MS): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

export default useDebounce;